"use strict";
exports.__esModule = true;
exports.chunk = void 0;
function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return [];
    }
    start = start == null ? 0 : start;
    end = end === undefined ? length : end;
    if (start < 0) {
        start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    // @ts-ignore
    length = start > end ? 0 : (end - start) >>> 0;
    start >>>= 0;
    var index = -1;
    var result = new Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}
function chunk(array, size) {
    size = Math.max(size, 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) {
        return [];
    }
    var index = 0;
    var resIndex = 0;
    var result = new Array(Math.ceil(length / size));
    while (index < length) {
        result[resIndex++] = slice(array, index, (index += size));
    }
    return result;
}
exports.chunk = chunk;
//# sourceMappingURL=chunk.js.map